import { useSelector, shallowEqual } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import moment from 'moment';
import NsSkyline from '@britishgasenergy/react-nucleus/dist/nuc-components/NsSkyline';

import { selectData as selectFmrsData } from 'state/fmrs/fmrs-slice';
import { selectMoveInDate } from 'state/move-in-date/move-in-date-slice';
import { NsExpander } from 'components/common/ns-expander/NsExpander';
import { usePartner } from 'components/app/routes/usePartner';
import { DATE_FORMAT, PARTNERS } from 'config/app-config';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';

export const priceCapTestId = 'priceCaptestId';
export const ssdBeforePriceCapExpiryMsgTestId =
  'ssdBeforePriceCapExpiryMsgTestId';
export const ssdAfterPriceCapExpiryMsgTestId =
  'ssdAfterPriceCapExpiryMsgTestId';

export const PriceCapBanner = () => {
  const { showPriceCapFeature } = useFlags();
  const { preferredStartDate } = useSelector(selectFmrsData, shallowEqual);
  const moveInDate = useSelector(selectMoveInDate, shallowEqual);

  const { activePartner } = usePartner();

  if (!showPriceCapFeature) {
    return null;
  }

  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];
  const customerPreferredStartDate = isMoveInJourney
    ? moveInDate
    : preferredStartDate;

  const mSSD = moment(customerPreferredStartDate, DATE_FORMAT);

  const mPriceCapExpiryDate = moment(showPriceCapFeature, DATE_FORMAT);
  const expiryDateWithDay = mPriceCapExpiryDate.format('Do MMMM YYYY');
  const expiryDateWithoutYear = mPriceCapExpiryDate.format('Do MMMM');
  const isSSDBeforePriceCapExpiryDate = mSSD.isBefore(mPriceCapExpiryDate);

  const getHeading = () => {
    return `Standard Variable rates will decrease on ${expiryDateWithDay}`;
  };

  const getMessage = () => {
    if (isSSDBeforePriceCapExpiryDate) {
      return `Our Standard Variable tariff rates are decreasing on ${expiryDateWithDay} in line with Ofgem's energy price cap. The personal projection below is based on current Standard Variable rates. It doesn't take into account the new lower rates from ${expiryDateWithoutYear}.`;
    }
    return `Our Standard Variable tariff rates are decreasing on ${expiryDateWithDay}. The personal projection below is based on new Standard Variable rates and includes the new lower rates from ${expiryDateWithoutYear}.`;
  };

  return (
    <NsSkyline data-testid={priceCapTestId}>
      <NsExpander type="skyline" icon="info" heading={getHeading()}>
        <p
          data-testid={
            isSSDBeforePriceCapExpiryDate
              ? ssdBeforePriceCapExpiryMsgTestId
              : ssdAfterPriceCapExpiryMsgTestId
          }
        >
          {getMessage()}{' '}
          <NsAnchor href="https://www.britishgas.co.uk/energy/price-cap.html">
            See our new rates
          </NsAnchor>
          .
        </p>
      </NsExpander>
    </NsSkyline>
  );
};

export default PriceCapBanner;
